import { Phone, Mail, Clock, Video } from "lucide-react";
import { WhatsAppIcon, IndiaIcon } from "@/components/Icons";
import { Reveal } from "@/components/Reveal";
import { BRAND } from "@/data/content";

export const Contact = () => {
  const channels = [
    { icon: Phone, label: "Call us", value: BRAND.phone, href: BRAND.phoneHref },
    { icon: WhatsAppIcon, label: "WhatsApp", value: BRAND.phone, href: BRAND.whatsapp, external: true },
    { icon: Mail, label: "Email", value: BRAND.email, href: `mailto:${BRAND.email}` },
  ];

  return (
    <section id="contact" className="py-20 sm:py-24 bg-ink text-white relative overflow-hidden grain" data-testid="contact">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-10">
          {/* LEFT — headline */}
          <div className="lg:col-span-5">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.22em] font-bold text-forest-light mb-4">Free claim review</p>
              <h2 className="text-4xl sm:text-5xl font-extrabold tracking-tighter leading-[1.05]">
                Let's get your money back.
              </h2>
              <p className="mt-5 text-zinc-400 text-lg max-w-md">
                Speak directly with a Sahi Claim Advisor and understand the next step for your case — with a free initial review and zero obligation.
              </p>
            </Reveal>
          </div>

          {/* MIDDLE — contact channels */}
          <div className="lg:col-span-4 lg:border-l lg:border-zinc-800 lg:pl-10">
            <Reveal delay={0.1}>
              <div className="space-y-5">
                {channels.map((c) => (
                  <a key={c.label} href={c.href} target={c.external ? "_blank" : undefined} rel={c.external ? "noreferrer" : undefined}
                    className="flex items-center gap-4 group" data-testid={`contact-${c.label.toLowerCase().replace(/\s/g, "-")}`}>
                    <span className="h-11 w-11 rounded-full border border-zinc-700 flex items-center justify-center text-forest-light group-hover:bg-forest group-hover:text-white group-hover:border-forest transition-colors">
                      <c.icon size={18} />
                    </span>
                    <div>
                      <div className="text-xs uppercase tracking-wider text-zinc-500">{c.label}</div>
                      <div className="font-semibold">{c.value}</div>
                    </div>
                  </a>
                ))}
              </div>
            </Reveal>
          </div>

          {/* RIGHT — hours + service badges */}
          <div className="lg:col-span-3 lg:border-l lg:border-zinc-800 lg:pl-10">
            <Reveal delay={0.2}>
              <div className="flex items-center gap-4">
                <span className="h-11 w-11 rounded-full border border-zinc-700 flex items-center justify-center text-forest-light">
                  <Clock size={18} />
                </span>
                <div>
                  <div className="text-xs uppercase tracking-wider text-zinc-500">Business hours</div>
                  <div className="font-semibold leading-snug">
                    <div className="whitespace-nowrap">Monday – Saturday</div>
                    <div className="whitespace-nowrap">10:00 AM – 6:00 PM</div>
                  </div>
                </div>
              </div>

              <div className="mt-6 flex flex-col gap-3">
                <span className="inline-flex items-center gap-2 rounded-full border border-zinc-700 px-4 py-2 text-sm font-medium text-zinc-200 w-fit" data-testid="badge-pan-india">
                  <IndiaIcon size={18} /> PAN India Services
                </span>
                <span className="inline-flex items-center gap-2 rounded-full border border-zinc-700 px-4 py-2 text-sm font-medium text-zinc-200 w-fit lg:whitespace-nowrap" data-testid="badge-online-consult">
                  <Video size={15} className="text-forest-light shrink-0" /> Online Consultation Available
                </span>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
